import React, {Suspense} from 'react';
import {Redirect, Route, Switch, BrowserRouter} from 'react-router-dom';

import Layouts from "../Layout/Funlove";
import Terms from "./terms";
import Policy from "./policy";
import errorNotfound from "./errorNotfound";
import NotFound from './Components/NotFound'

const Home = React.lazy(() => import('./Home'));
const Movies = React.lazy(() => import('./Movies'));
const IframeVideo = React.lazy(() => import('./Movies/IframeVideo'));
const Categories = React.lazy(() => import('./Categories'));
const Popular = React.lazy(() => import('./Popular'));
const MovieDetail = React.lazy(() => import('./Movies/Detail'));
const PornStars = React.lazy(() => import('./PornStars/index'));
const PornStarDetail = React.lazy(() => import('./PornStars/Detail'));
function Funlove(props) {
    return (
        <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
            <Layouts>
                <Switch>
                        <Route exact={true} path="/" component={Home}/>
                        <Route path="/movies/:page?/:sort?" component={Movies}/>
                        <Route path="/popular/:page?/:sort?" component={Popular}/>
                        <Route path="/movie/:alias" component={MovieDetail}/>
                        <Route path="/categorices/:alias/:page?/:sort?" component={Categories}/>
                        <Route path="/pornstars/:page?" component={PornStars}/>
                        <Route path="/pornstar/:alias" component={PornStarDetail}/>
                        <Route path="/terms" component={Terms}/>
                        <Route path="/policy" component={Policy}/>
                        <Route path="/error" component={NotFound}/>
                        <Route path="/404" component={errorNotfound}/>
                        <Route path="/jav/:page?/:sort?" component={Movies}/>
                        <Route path="/jav-hd/:page?/:sort?" component={Movies}/>
                        <Route path="/jav-free/:page?/:sort?" component={Movies}/>
                        <Route path="/watch-jav-online-free/:page?/:sort?" component={Movies}/>
                        <Route path="/video-iframe/:alias" component={IframeVideo}/>
                        <Route component={NotFound}/>
                </Switch>
            </Layouts>
        </BrowserRouter>
        </Suspense>
    );
}

export default Funlove;
